// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Invitation_invites__pJHlt {
  overflow: -moz-scrollbars-none;
  overflow: -moz-hidden-unscrollable;
  scrollbar-width: none;
  max-height: 200px;
  overflow-y: scroll;
}
.Invitation_invites__pJHlt::-webkit-scrollbar {
  display: none;
  width: 0 !important;
  -ms-overflow-style: none;
}

.Invitation_invite__LXe4H {
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #E5E6EE;
  margin: 16px 16px 0;
}
.Invitation_invite__company__2OB4H {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.Invitation_invite__companyWarning__Ouvbc {
  display: none;
}
.Invitation_invite__companyAvatar__bkhPa {
  width: 40px;
  height: 40px;
  margin-right: 12px;
  flex-shrink: 0;
}
.Invitation_invite__companyTitle__akh0b {
  font-family: Roboto, serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0;
  color: #8E8E93;
  margin-bottom: 4px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  display: -webkit-box;
}
.Invitation_invite__companyName__R-oSa {
  font-family: Roboto, serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  display: -webkit-box;
}
.Invitation_invite__buttons__G61jE {
  display: flex;
  justify-content: space-between;
}
.Invitation_invite__buttonsItem__mZmWn {
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(50% - 8px);
  cursor: pointer;
}
.Invitation_invite__buttonsItem__mZmWn:disabled {
  cursor: not-allowed;
  pointer-events: auto;
}
.Invitation_invite__buttonsItem__mZmWn.Invitation_Decline__Fc0In {
  border: 1px solid #E23834;
  color: #E23834;
}
.Invitation_invite__buttonsItem__mZmWn.Invitation_Accept__X0UeS {
  color: #3EBF71;
  border: 1px solid #3EBF71;
}
.Invitation_inviteCollapsed__GdYLK {
  border-radius: 12px;
  display: flex;
  justify-content: center;
  border: none;
  margin-top: 0;
  padding: 10px;
  position: relative;
}
.Invitation_inviteCollapsed__GdYLK .Invitation_invite__company__2OB4H {
  margin-bottom: 12px;
}
.Invitation_inviteCollapsed__GdYLK .Invitation_invite__companyAvatar__bkhPa {
  margin-right: 0;
}
.Invitation_inviteCollapsed__GdYLK .Invitation_invite__buttons__G61jE {
  display: none;
}
.Invitation_inviteCollapsed__GdYLK .Invitation_invite__companyRight__SUR-f {
  display: none;
}
.Invitation_inviteCollapsed__GdYLK .Invitation_invite__companyWarning__Ouvbc {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: #E59F42;
  border: 2px solid #fff;
  border-radius: 50%;
  position: absolute;
  top: 0;
  right: 0px;
  width: 18px;
  height: 18px;
  font-size: 9px;
  text-align: center;
  font-weight: 900;
}

@media (max-width: 700px) {
  .Invitation_invite__LXe4H {
    margin-top: 3px;
    margin-bottom: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/companies/Invitation/Invitation.module.scss","webpack://./../../packages/sdk/src/assets/mixins.scss"],"names":[],"mappings":"AAGA;ECUE,8BAAA;EACA,kCAAA;EACA,qBAAA;EDTA,iBAAA;EACA,kBAAA;AAIF;ACME;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;ADJJ;;AANA;EACE,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AASF;AAPE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AASJ;AARI;EACE,aAAA;AAUN;AARI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAUN;AARI;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,4BAAA;EACA,oBAAA;AAUN;AARI;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,4BAAA;EACA,oBAAA;AAUN;AANE;EACE,aAAA;EACA,8BAAA;AAQJ;AAPI;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;AASN;AAPM;EACE,mBAAA;EACA,oBAAA;AASR;AANM;EACE,yBAAA;EACA,cAAA;AAQR;AANM;EACE,cAAA;EACA,yBAAA;AAQR;AAJE;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;AAMJ;AALI;EACE,mBAAA;AAON;AAJI;EACE,eAAA;AAMN;AAHI;EACE,aAAA;AAKN;AAFI;EACE,aAAA;AAIN;AAFI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAIN;;AACA;EACE;IACE,eAAA;IACA,mBAAA;EAEF;AACF","sourcesContent":["@import '@roolz/sdk/assets/mixins.scss';\n@import '@/assets/scss/config.module.scss';\n\n.invites {\n  @include invisible-scroll;\n\n  max-height: 200px;\n  overflow-y: scroll;\n}\n\n.invite {\n  border-radius: 12px;\n  padding: 16px;\n  border: 1px solid #E5E6EE;\n  margin: 16px 16px 0;\n\n  &__company {\n    display: flex;\n    align-items: center;\n    margin-bottom: 12px;\n    &Warning {\n      display: none;\n    }\n    &Avatar {\n      width: 40px;\n      height: 40px;\n      margin-right: 12px;\n      flex-shrink: 0;\n    }\n    &Title {\n      font-family: Roboto, serif;\n      font-size: 12px;\n      font-weight: 400;\n      line-height: 14px;\n      letter-spacing: 0;\n      color: #8E8E93;\n      margin-bottom: 4px;\n      word-break: break-all;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      -webkit-line-clamp: 1;\n      -webkit-box-orient: vertical;\n      display: -webkit-box;\n    }\n    &Name {\n      font-family: Roboto, serif;\n      font-size: 14px;\n      font-weight: 500;\n      line-height: 16px;\n      letter-spacing: 0;\n      word-break: break-all;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      -webkit-line-clamp: 1;\n      -webkit-box-orient: vertical;\n      display: -webkit-box;\n    }\n  }\n\n  &__buttons {\n    display: flex;\n    justify-content: space-between;\n    &Item {\n      padding: 8px 16px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: calc(50% - 8px);\n      cursor: pointer;\n\n      &:disabled {\n        cursor: not-allowed;\n        pointer-events: auto;\n      }\n\n      &.Decline {\n        border: 1px solid #E23834;\n        color: #E23834;\n      }\n      &.Accept {\n        color: #3EBF71;\n        border: 1px solid #3EBF71;\n      }\n    }\n  }\n  &Collapsed {\n    border-radius: 12px;\n    display: flex;\n    justify-content: center;\n    border: none;\n    margin-top: 0;\n    padding: 10px;\n    position: relative;\n    .invite__company {\n      margin-bottom: 12px;\n    }\n\n    .invite__companyAvatar {\n      margin-right: 0;\n    }\n\n    .invite__buttons {\n      display: none;\n    }\n\n    .invite__companyRight {\n      display: none;\n    }\n    .invite__companyWarning {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: #fff;\n      background: #E59F42;\n      border: 2px solid #fff;\n      border-radius: 50%;\n      position: absolute;\n      top: 0;\n      right: 0px;\n      width: 18px;\n      height: 18px;\n      font-size: 9px;\n      text-align: center;\n      font-weight: 900;\n    }\n  }\n}\n\n@media(max-width: $mobile-sidebar-breakpoint-width) {\n  .invite {\n    margin-top: 3px;\n    margin-bottom: 16px;\n  }\n}\n","@mixin ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@mixin applyToChildrenExceptLast($property, $value) {\n  & > *:not(:last-child) {\n    #{$property}: #{$value}\n  }\n}\n\n@mixin invisible-scroll {\n  overflow: -moz-scrollbars-none;\n  overflow: -moz-hidden-unscrollable;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n    width: 0 !important;\n    -ms-overflow-style: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mobileSidebarBreakpointWidth": `700px`,
	"sidebarWidth": `334px`,
	"invites": `Invitation_invites__pJHlt`,
	"invite": `Invitation_invite__LXe4H`,
	"invite__company": `Invitation_invite__company__2OB4H`,
	"invite__companyWarning": `Invitation_invite__companyWarning__Ouvbc`,
	"invite__companyAvatar": `Invitation_invite__companyAvatar__bkhPa`,
	"invite__companyTitle": `Invitation_invite__companyTitle__akh0b`,
	"invite__companyName": `Invitation_invite__companyName__R-oSa`,
	"invite__buttons": `Invitation_invite__buttons__G61jE`,
	"invite__buttonsItem": `Invitation_invite__buttonsItem__mZmWn`,
	"Decline": `Invitation_Decline__Fc0In`,
	"Accept": `Invitation_Accept__X0UeS`,
	"inviteCollapsed": `Invitation_inviteCollapsed__GdYLK`,
	"invite__companyRight": `Invitation_invite__companyRight__SUR-f`
};
export default ___CSS_LOADER_EXPORT___;
